var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 96 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M439 986H204q-53.95 0-91.975-37.969Q74 910.062 74 855V304q0-53.95 39-92.475Q152 173 215 173h124q20-38 59.755-61.5T485 88q47 0 86.5 23t60.5 62h124q53.95 0 91.975 38.525Q886 250.05 886 304v192H750V309h-71v19q0 46-32 78t-78 32H391q-46 0-78-32t-32-78v-19h-71v541h229v136Zm182-246 170-170q18.8-18 45.4-18 26.6 0 45.6 18.5t19 45.1q0 26.6-19 45.4L668 874q-19 19-47 19t-48-19L473 774q-19-18.8-19-45.4 0-26.6 18.5-45.6t45.5-19q27 0 45 19l58 57ZM480 294q17 0 28.5-11.5T520 254q0-17-11.5-28.5T480 214q-16 0-28 11.5T440 254q0 17 12 28.5t28 11.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomArchive);
export default __webpack_public_path__ + "static/media/custom-archive.c34aaadc98c905033e081c92680a6ba7.svg";
export { ForwardRef as ReactComponent };